import React from 'react';
import {Link} from 'react-router-dom'

const e = React.createElement;


function Register() {}
Register.prototype = Object.create(React.Component.prototype);


Register.prototype.render = function() {
  var tr_first = "Voornaam";
  var tr_last = "Achternaam";
  var tr_email = "E-mail";
  var tr_pass = "Wachtwoord";
  var tr_create = "account maken";
  var tr_byreg = e('div', {key:"15", className:"footnote"}, [e('span', {key:"151"}, "Door een account te maken ga je akkoord met de "), e('a', {key:"152", href:"/terms", target:"_blank", rel:"noopener noreferrer"}, "Algemene Voorwaarden"), e('span', {key:"153"}, ".")]);
  var tr_tologin = e('div', {key:"2", className:"footnote"}, e(Link, {to:"/", onClick:this.props.switchContent.bind(this, "login")}, "Naar inloggen"));

  if(this.props.language === "EN") {
    tr_first = "First name";
    tr_last = "Last name";
    tr_email = "Email";
    tr_pass = "Password";
    tr_create = "create account";
  var tr_byreg = e('div', {key:"15", className:"footnote"}, [e('span', {key:"151"}, "By creating an account you agree to the "), e('a', {key:"152", href:"/terms", target:"_blank", rel:"noopener noreferrer"}, "Terms and Conditions"), e('span', {key:"153"}, ".")]);
    tr_tologin = e('div', {key:"2", className:"footnote"}, e(Link, {to:"/", onClick:this.props.switchContent.bind(this, "login")}, "Go to login"));
  }

  return e('div', null, [
    e('form', {key:"1", onSubmit:this.props.handleRegister}, [
      e('div', {key:"11"}, e('input', {type:"text", value:this.props.firstname, onChange:this.props.handleChange.bind(this, "firstname"), placeholder:tr_first, autoFocus:true})),
      e('div', {key:"12"}, e('input', {type:"text", value:this.props.lastname, onChange:this.props.handleChange.bind(this, "lastname"), placeholder:tr_last})),
      e('div', {key:"13"}, e('input', {type:"text", value:this.props.email, onChange:this.props.handleChange.bind(this, "email"), placeholder:tr_email})),
      e('div', {key:"14"}, e('input', {type:"password", value:this.props.password, onChange:this.props.handleChange.bind(this, "password"), placeholder:tr_pass})),
      tr_byreg,
      e('div', {key:"16"}, e('input', {type:"submit", value:tr_create, disabled:this.props.register_is_fetching})),
    ]),
    tr_tologin,
  ]);
}


export default Register



//////////////////
// WEBPACK FOOTER
// ../_Skelet/src/components/ModalAccount_Register.js
// module id = 249
// module chunks = 0